import gql from "graphql-tag";

export const GET_PRESIGNED_URL = gql`
  query getPreSignedUrlAgent($input: PreSignedInput!) {
    getPreSignedUrlAgent(input: $input) {
      data {
        key
        url
      }
    }
  }
`;

export const GET_SIGNED_URL = gql`
  query getSignedUrlForAgent($input: AgentSignedUrlDTO!) {
    getSignedUrlForAgent(input: $input) {
      link
    }
  }
`;
